export const SECTION_CHANGE = 'section changed';